/* this file added by Bearer Web Developer  */
import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import styles from './reservedOrdersPopup.module.scss';
import { useAppState } from "../../states/app-state";
import { observer } from "mobx-react-lite";
import ManageOrder from "./manageOrder";
import ReservedOrders from "./reservedOrders";
import EditOrder from "./editOrder";
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer

const ReservedOrdersPopup: React.FC = observer(() => {
   const appState = useAppState();
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('md')); // 900px max width
   const {
      reservedOrdersOpen, setReservedOrdersOpen, activeManageOrder, handleEdit,
      activeEditOrder, activeManageOrderFromShortcut
   } = appState?.ReservedOrders;
   const open = reservedOrdersOpen;
   const closeManageOrder = () => {
      appState?.ReservedOrders?.setActiveManageOrder(null);
      if (appState?.ReservedOrders?.sortBasis) appState?.ReservedOrders?.setSortBasis(null);
      if (activeManageOrderFromShortcut) {
         if (reservedOrdersOpen) setReservedOrdersOpen(false);
      }
   }
   const handleClose = () => {
      if (activeManageOrder) closeManageOrder();
      else setReservedOrdersOpen(false);
   }
   const { theme: themeMode } = useThemeMode(); // added by Bearer Web Developer
   return (
      <>
         {
            isMobile ?
               <Dialog open={open} onClose={handleClose}
                  slotProps={{
                     paper: {
                        sx: {
                           borderRadius: "10px", margin: "10px", minHeight: "calc(100% - 20px)", maxWidth: "100%", // minHeight is 100% - margin top and bottom
                           backgroundColor: themeMode === "dark" ? 'var(--neutral-hsb-15, #262626)' : '#fff'
                        },
                        classes: { root: styles.paper_dialog, }
                     },
                  }}>
                  {!activeManageOrder && <ReservedOrders />}
                  {!!activeManageOrder && !activeEditOrder && <ManageOrder handleClose={closeManageOrder} />}
                  {!!activeEditOrder && !!activeManageOrder && <EditOrder handleClose={() => { handleEdit(false) }} />}
               </Dialog>
               :
               open &&
               <div className={styles.decktop} data-theme={themeMode}> {/* data-theme property added by Bearer Web Developer */}
                  {!activeManageOrder && <ReservedOrders />}
                  {!!activeManageOrder && !activeEditOrder && <ManageOrder handleClose={closeManageOrder} />}
                  {!!activeEditOrder && !!activeManageOrder && <EditOrder handleClose={() => { handleEdit(false) }} />}
               </div>
         }
      </>
   )
});
export default ReservedOrdersPopup;

